import React from "react";
import { Icon } from "antd";

export default function DocumentIcon(status , documents){
    if(!documents.length){
        return <Icon type="check-circle" theme="filled" style={{ color: "#cacaca",paddingRight: "20px",  fontSize: "16px" }} />;
    }else if(status === "Pending"){
        return (
            <React.Fragment>
                <Icon type="check-circle" theme="filled" style={{ color: "#F2994A", paddingRight: "20px", fontSize: "16px"}} />
            </React.Fragment>
        );
    }else if(status === "Approved"){
        return (
            <React.Fragment>
                <Icon type="check-circle" theme="filled" style={{ color: "#27AE60", paddingRight: "20px", fontSize: "16px"}} />
            </React.Fragment>
        );
    }else if(status === "Rejected"){
        return (
            <React.Fragment>
                <Icon type="close-circle" theme="filled" style={{ color: "red", paddingRight: "20px", fontSize: "18px"}} />
            </React.Fragment>
        );
    }
}